import React from "react";
import { UserProfileService } from "../../types";
import { useCopies } from "shared/hooks/useCopies";
import FormTextField from "shared/form/fields/textField";
import UserFieldsNameEnum from "apps/console/modules/user/details/enum";
// import FormSelectDropdownField from "shared/form/fields/selectDropdown";
//TODO:ASF While enabling language field, add validation for that.
export default function UserProfileInfo(props: { service: UserProfileService }) {
  const copies = useCopies();
  return (
    <React.Fragment>
      <FormTextField label={copies.get("username")} name={UserFieldsNameEnum.WORK_EMAIL} required={true} disabled />
      <FormTextField label={copies.get("first.name")} name={UserFieldsNameEnum.FIRST_NAME} required={true} />
      <FormTextField label={copies.get("last.name")} name={UserFieldsNameEnum.LAST_NAME} required={true} />
      <FormTextField label={copies.get("job.title")} name={UserFieldsNameEnum.JOB_TITLE} required={true} />
      {/* <FormSelectDropdownField
        label={copies.get("language.type")}
        name={UserFieldsNameEnum.LANGUAGE_TYPE}
        required={true}
        options={props.service.languageOptions}
      /> */}
    </React.Fragment>
  );
}
